var __jsx = React.createElement;
import React from "react";
import { ELSAccordion } from "components/common/elsevier/Accordion/Accordion";
import { ELSAccordionDetails } from "components/common/elsevier/Accordion/AccordionDetails";
import { ELSAccordionSummary } from "components/common/elsevier/Accordion/AccordionSummary";
import { ELSGrid } from "components/common/elsevier/Grid/Grid";
import NavigateDownIcon from "components/common/elsevier/Icons/NavigateDownIcon";
import Styles from "../Styles.module.scss";
function Accordion(_ref) {
  var accordionDatabases = _ref.accordionDatabases;
  return /*#__PURE__*/React.createElement(ELSGrid, {
    container: true,
    spacing: 2,
    alignItems: "center",
    className: Styles.moreDatabaseContainer
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 12,
    className: Styles.moreDatabaseContainer__moreDatabase,
    "data-cy": "need-more-dbs-tagline"
  }, /*#__PURE__*/React.createElement("strong", null, "Need more databases?")), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 12,
    "data-cy": "explore-more-dbs-tagline"
  }, "Explore other databases, or contact our experts to help you choose the best database to suit your needs."), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 12
  }, accordionDatabases.map(function (_ref2) {
    var searchcode = _ref2.searchcode,
      label = _ref2.label,
      description = _ref2.description;
    return /*#__PURE__*/React.createElement(ELSAccordion, null, /*#__PURE__*/React.createElement(ELSAccordionSummary, {
      expandIcon: /*#__PURE__*/React.createElement(NavigateDownIcon, {
        style: {
          color: "#0056D6"
        }
      }) // This will be refined.
      ,
      className: Styles.moreDatabaseContainer__accordionSummary,
      "aria-controls": "".concat(searchcode, "-panel-content"),
      id: "".concat(searchcode, "-panel-header"),
      "data-cy": "".concat(label, "-accordion-title")
    }, label), /*#__PURE__*/React.createElement(ELSAccordionDetails, {
      className: Styles.moreDatabaseContainer__accordionDetails,
      "data-cy": "".concat(label, "-accordion-description")
    }, description));
  })));
}
export default Accordion;